import { WorkerTabContainer } from '../../workerTab/WorkerTabContainer';

/** Route element for RCP worker (/main/dod/worker). */
export const WorkerRoute = (): JSX.Element => <WorkerTabContainer />;
